<script>
  import { slide } from "svelte/transition";
  import { cubicInOut } from "svelte/easing";

  export let shouldAnimate = false;
  let wrapperClass = "";

  export { wrapperClass as class };
</script>

<!-- I created this wrapper because there is an issue with JSDOM that causes tests to fail if the components
 under test have the transition directive applied. This is apparently a known issue as documented on the svelte-testing
 site : https://testing-library.com/docs/svelte-testing-library/faq/#why-arent-transition-events-running. I didn't
 get very far with the suggested approach, so I just created this wrapper instead.

Yes, this is currently too specific, but if we ever need it for anything else, we can expand it to create
subcomponents that allow for greater variety of transitions.-->

{#if shouldAnimate}
  <div class={wrapperClass} transition:slide|global={{ duration: 500, easing: cubicInOut }}>
    <slot />
  </div>
{:else}
  <slot />
{/if}
